// The vocabulary of a Posist delta menu sync, shared by the two screens that
// report one: the modal that starts a run, and the dashboard panel that shows
// whatever is running. Kept here rather than in either of them so the same
// store cannot be called "Syncing…" on one screen and something else on the
// other.

// Per-store outcome wording. `skipped` is deliberately not an error: it means a
// full or delta sync already held that store's lock, which is a normal outcome.
export const SYNC_STATUS_LABEL = {
  pending: "Queued",
  running: "Syncing…",
  success: "Done",
  failed: "Failed",
  skipped: "Already running",
};

export const SYNC_STATUS_CLASS = {
  pending: "pro-text-muted",
  running: "pro-text-primary",
  success: "pro-text-success",
  failed: "pro-text-danger",
  skipped: "pro-text-warning",
};

// Two different paths write isChange = 1 on a product: a staged diff the admin
// can approve, and a product Posist has deleted. Only the first is work - the
// "Changed only" listing excludes the delisted rows, because there is no diff
// behind them and approving one never clears it. The server sends them apart as
// `flagged` and `deleted`, and pre-summed as `needs_approval`, which now tracks
// `flagged`. Falls back to `flagged` so a product service deployed before the
// field existed still shows the number it used to send.
export const needsApprovalOf = (store) =>
  store?.needs_approval ?? store?.flagged ?? 0;

export const sumBy = (stores, pick) =>
  (stores ?? []).reduce((total, store) => total + (pick(store) ?? 0), 0);

// How far through its own sync a store is. There is no progress inside a store
// - it is one job, and the worker reports only which state it is in - so the
// bar is honest about that: empty while queued, an indeterminate stripe while
// running, and full once the worker is done with it, whatever the outcome.
export const SYNC_BAR_STATE = {
  pending: { percent: 0, tone: "idle" },
  running: { percent: 100, tone: "running" },
  success: { percent: 100, tone: "success" },
  failed: { percent: 100, tone: "failed" },
  skipped: { percent: 100, tone: "skipped" },
};

// Stores the worker has finished with, whatever the outcome - what the overall
// bar fills on. Derived from the counts rather than the rows so it matches the
// server's own idea of done.
export const finishedCountOf = (run) =>
  (run?.counts?.success ?? 0) +
  (run?.counts?.failed ?? 0) +
  (run?.counts?.skipped ?? 0);
